export default __webpack_public_path__ + "static/media/red-down.984f82e2.svg";